import { SingleTab } from "./SingleTab";
import { TabsProps } from "./Tabs";

export type { TabsProps };
export { SingleTab };
export { default } from "./Tabs";
